import React from 'react';
import {inject, observer} from 'mobx-react';
import {Button, Modal} from '@enos/dpl';
import localeText, {getLocale, setLocaleToCookie} from '@locale';
import {formatLanToText, switchLocale} from '~/utils/tools';
import {DesktopOrTablet, Mobile} from '../Responsive';
import MobileNavBack from '../MobileNavBack';
import './index.less';
import './mobile.less';
import store from './store';

@inject((stores, props) => {
  const {userStore, sessionStore} = stores;
  return {
    ...props,
    sessionStore,
    userStore,
    uiStore: store
  };
})
@observer
class LanguageSwitch extends React.Component {
  static defaultProps = {
    prefixClass: 'route-language-switcher'
  };

  componentDidMount() {
    setLocaleToCookie(getLocale(), document.location.protocol.split(':')[0] === 'https' && {
      Secure: true,
      SameSite: 'None'
    });
    this.props.uiStore.setLanKey(getLocale());
  }

  handleSubmit = () => {
    const {uiStore} = this.props;
    switchLocale(uiStore.chosenLanKey);
    uiStore.toggleLanguageSwitchModal(false);
  };

  renderLan = arr => arr.map(i => (
    <div className='language-item' {...{[['key'][0]]: i}} onClick={() => switchLocale(i)}>
      <span>{formatLanToText(i)}</span>
      {this.props.uiStore.chosenLanKey === i ? <i className='dpl20_right_circle_so' /> : ''}
    </div>
  ));

  renderLanOnMobile = arr => arr.map(i => (
    <div className='language-item' onClick={() => this.props.uiStore.setLanKey(i)} {...{[['key'][0]]: i}}>
      <span>{formatLanToText(i)}</span>
      {this.props.uiStore.chosenLanKey === i ? <i className='dpl20_right_circle_so' /> : ''}
    </div>
  ));

  render() {
    const {uiStore, prefixClass, title} = this.props;
    return (
      <Modal
        className='language-switch-modal'
        maskClosable={false}
        visible={uiStore.showLanguageSwitchModal}
        footer={null}
        onCancel={() => uiStore.toggleLanguageSwitchModal(false)}
      >
        <div className={prefixClass}>
          <DesktopOrTablet>
            <h3 className='list-header'>{title || localeText('COMMON.BTN_LAN_SWITCH')}</h3>
            <div className='list-language'>{this.renderLan(this.props.sessionStore.workingOrganizationLan)}</div>
          </DesktopOrTablet>
          <Mobile>
            <MobileNavBack title={localeText('COMMON.BTN_LAN_SWITCH')} onBack={() => uiStore.toggleLanguageSwitchModal(false)} />
            <div className='language-switch-list'>
              {this.renderLanOnMobile(this.props.sessionStore.workingOrganizationLan)}
              <Button className='btn-language-switch' type='primary' onClick={this.handleSubmit}>
                {localeText('COMMON.BTN_SUBMIT')}
              </Button>
            </div>
          </Mobile>
        </div>
      </Modal>
    );
  }
}

export function showLanguageSwitcherModal() {
  store.toggleLanguageSwitchModal(true);
}

export default LanguageSwitch;
